{
  "title": "Earth Tremor",
  "source": "Xanathar's Guide to Everything/Elemental Evil Player's Companion",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self (10-foot radius)",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You cause a tremor in the ground in a 10-foot radius. Each creature other than you in that area must make a Dexterity saving throw. On a failed save, a creature takes 1d6 bludgeoning damage and is knocked prone. If the ground in that area is loose earth or stone, it becomes difficult terrain until cleared.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d6 for each slot level above 1st."
  ],
  "spellLists": ["bard", "druid", "eldritch-knight", "sorcerer", "wizard"]
}
